import { rem, Text, Input } from "@mantine/core";
import { useController } from "react-hook-form";
import { useTheme } from "../../hooks";
interface Props {
  id: string;
  defaultValue: string | undefined;
  maxWidth: string | undefined;
  suffix: string | undefined;
}
const TriangleInputChild = ({ id, defaultValue, maxWidth, suffix = "" }: Props) => {
  const theme = useTheme();
  const { field } = useController({
    name: id,
    defaultValue,
  });
  return (
    <Input
      {...field}
      rightSection={<Text color={theme.colors.text[0]}>{suffix}</Text>}
      styles={{
        wrapper: { padding: 0, maxWidth: maxWidth },
        input: {
          padding: rem(4),
          height: rem(30),
          minHeight: rem(30),
          borderWidth: 0.5,
        },
      }}
    />
  );
};
export default TriangleInputChild;
